// src/api/updateUserSurvey.ts
import { useMutation } from 'react-query'
import { endpoints } from '@app/api/config'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { AxiosResponse } from 'axios'
import { ApiErrorResponse } from 'BackendApi'

// No params: server derives user from auth context.
const patchUserSurvey = async (): Promise<boolean> => {
  const apiResponse: AxiosResponse<boolean> = await apiAuthClient.patch(
    endpoints.updateUserSurvey
  )
  return apiResponse.data
}

export const useUpdateUserSurvey = () =>
  useMutation<boolean, ApiErrorResponse>(patchUserSurvey)
